import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-chase-counts-by-status-report",
  templateUrl: "./chase-counts-by-status-report.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChaseCountsByStatusReportComponent {

  filters: string[];
  dashboardType = LookerRiskDashboardType.CHASE_COUNTS_BY_STATUS;
  hideFilters: string[];

  constructor() {
    this.filters = ["Projects"];
    this.hideFilters = [HideFilters.USER_ID2, HideFilters.USER_ID, HideFilters.USER_ID3, HideFilters.ORG_ID, HideFilters.PROJECT_ID, HideFilters.PROJECT_NAME2,
                        HideFilters.ORGANIZATION_NAME];
  }

}
